import React, { FC, useCallback, memo } from 'react';
import { Field, FieldProps } from 'formik';
import { setFieldValueAndTouched, withErrorMessage } from '@minecraft.utils';
import Checkbox from '@minecraft.checkbox';

type Props = {
  id?: string;
  label?: string;
  count?: number;
  name: string;
  error?: string;
  testId?: string;
  children?: any;
  onChange?: (e?: any) => void;
  disabled?: boolean;
};

const SimpleCheckbox: FC<Props & FieldProps> = ({ field, label, form, onChange, ...props }) => {
  const handleCheckboxChange = useCallback(
    (e) => {
      setFieldValueAndTouched(field.name, !field.value, form);

      if (onChange) {
        onChange(e);
      }
    },
    [field.name, field.value, form, onChange]
  );

  return <Checkbox isChecked={field.value} label={label} onChange={handleCheckboxChange} {...props} />;
};

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * If this component is used in application code, we want to replace it.
 *
 * If it's used for a boolean field in the formik form use ConnectedCheckboxInput
 * If it's used for a list of values in the formik form use CheckboxGroupInput
 *
 * import { ConnectedCheckboxInput, CheckboxGroupInput } from '@minecraft.molecules'
 *
 * // where fiieldName is a boolean value in the formik state
 * <ConnectedCheckboxInput name="fieldName" label="Field Label" />
 *
 * // where fiieldName is a list of values in the formik state
 * <CheckboxGroupInput name="fieldName" label="Field Label" options={[{ value: '1', label: 'option 1' }, { value: '2', label: 'option 2' }]} />
 * for any props that are not currently implemented we should add the functionality
 */
const FormikSimpleCheckbox: FC<Props> = (props) => (
  <Field {...props}>{(fieldProps) => withErrorMessage(SimpleCheckbox)({ ...props, ...fieldProps })}</Field>
);

export default memo<Props>(FormikSimpleCheckbox);
